import React, {createContext} from 'react';

const default_value = {
  data: null,
  not_found: false,
  handle: ''
};

export const EntityContext = createContext(default_value);